// --- Customer tracking ---
export const FF_CUSTOMER_TRACKING_PAGE = "delivery.customer.tracking_page" as const;
export const FF_CUSTOMER_LIVE_MAP = "delivery.customer.live_map" as const;
export const FF_CUSTOMER_DRIVER_INFO = "delivery.customer.driver_info" as const;
export const FF_CUSTOMER_ETA_DISPLAY = "delivery.customer.eta_display" as const;
export const FF_CUSTOMER_DELIVERY_PROOF = "delivery.customer.delivery_proof" as const;
export const FF_CUSTOMER_REALTIME_UPDATES = "delivery.customer.realtime_updates" as const;
export const FF_CUSTOMER_RATING = "delivery.customer.rating" as const;
export const FF_MAP_PROVIDER_MAPBOX = "delivery.customer.map_provider_mapbox" as const;

// --- Driver portal ---
export const FF_PORTAL_REGISTRATION = "delivery.portal.registration" as const;
export const FF_PORTAL_LOGIN = "delivery.portal.login" as const;
export const FF_PORTAL_DASHBOARD = "delivery.portal.dashboard" as const;
export const FF_PORTAL_ROUTE_VIEW = "delivery.portal.route_view" as const;
export const FF_DRIVER_ROUTE_OPT = "delivery.portal.route_optimization" as const;
export const FF_PORTAL_STATUS_UPDATES = "delivery.portal.status_updates" as const;
export const FF_PORTAL_PROOF_UPLOAD = "delivery.portal.proof_upload" as const;
export const FF_PORTAL_GPS_TRACKING = "delivery.portal.gps_tracking" as const;
export const FF_PORTAL_EARNINGS = "delivery.portal.earnings" as const;
export const FF_PORTAL_NOTIFICATIONS = "delivery.portal.notifications" as const;

// --- Admin management ---
export const FF_ADMIN_FLEET_OVERVIEW = "delivery.admin.fleet_overview" as const;
export const FF_ADMIN_DRIVER_MANAGEMENT = "delivery.admin.driver_management" as const;
export const FF_ADMIN_ROUTE_PLANNING = "delivery.admin.route_planning" as const;
export const FF_ADMIN_ZONE_MANAGEMENT = "delivery.admin.zone_management" as const;
export const FF_ADMIN_COD_MANAGEMENT = "delivery.admin.cod_management" as const;
export const FF_ADMIN_DRIVER_ASSIGNMENT = "delivery.admin.driver_assignment" as const;
export const FF_ADMIN_ROUTE_OPTIMIZATION = "delivery.admin.route_optimization" as const;
export const FF_ADMIN_BULK_ASSIGN = "delivery.admin.bulk_assign" as const;
export const FF_ADMIN_DRIVER_CREATION = "delivery.admin.driver_creation" as const;
export const FF_ADMIN_PERFORMANCE_CARDS = "delivery.admin.performance_cards" as const;

// --- Analytics ---
export const FF_ANALYTICS_OPERATIONAL = "delivery.analytics.operational" as const;
export const FF_ANALYTICS_FINANCIAL = "delivery.analytics.financial" as const;
export const FF_ANALYTICS_CUSTOMER = "delivery.analytics.customer" as const;
export const FF_ANALYTICS_ZONE_HEATMAP = "delivery.analytics.zone_heatmap" as const;
export const FF_ANALYTICS_DRIVER_PERFORMANCE = "delivery.analytics.driver_performance" as const;
export const FF_ANALYTICS_ETA_ACCURACY = "delivery.analytics.eta_accuracy" as const;
export const FF_ANALYTICS_COD_COLLECTION = "delivery.analytics.cod_collection" as const;
export const FF_ANALYTICS_COST_PER_ORDER = "delivery.analytics.cost_per_order" as const;
export const FF_ANALYTICS_TREND_CHARTS = "delivery.analytics.trend_charts" as const;

/** All flag keys as a union type for type safety */
export type DeliveryFlagKey =
  | typeof FF_CUSTOMER_TRACKING_PAGE
  | typeof FF_CUSTOMER_LIVE_MAP
  | typeof FF_CUSTOMER_DRIVER_INFO
  | typeof FF_CUSTOMER_ETA_DISPLAY
  | typeof FF_CUSTOMER_DELIVERY_PROOF
  | typeof FF_CUSTOMER_REALTIME_UPDATES
  | typeof FF_CUSTOMER_RATING
  | typeof FF_PORTAL_REGISTRATION
  | typeof FF_PORTAL_LOGIN
  | typeof FF_PORTAL_DASHBOARD
  | typeof FF_PORTAL_ROUTE_VIEW
  | typeof FF_DRIVER_ROUTE_OPT
  | typeof FF_PORTAL_STATUS_UPDATES
  | typeof FF_PORTAL_PROOF_UPLOAD
  | typeof FF_PORTAL_GPS_TRACKING
  | typeof FF_PORTAL_EARNINGS
  | typeof FF_PORTAL_NOTIFICATIONS
  | typeof FF_ADMIN_FLEET_OVERVIEW
  | typeof FF_ADMIN_DRIVER_MANAGEMENT
  | typeof FF_ADMIN_ROUTE_PLANNING
  | typeof FF_ADMIN_ZONE_MANAGEMENT
  | typeof FF_ADMIN_COD_MANAGEMENT
  | typeof FF_ADMIN_DRIVER_ASSIGNMENT
  | typeof FF_ADMIN_ROUTE_OPTIMIZATION
  | typeof FF_ADMIN_BULK_ASSIGN
  | typeof FF_ADMIN_DRIVER_CREATION
  | typeof FF_ADMIN_PERFORMANCE_CARDS
  | typeof FF_ANALYTICS_OPERATIONAL
  | typeof FF_ANALYTICS_FINANCIAL
  | typeof FF_ANALYTICS_CUSTOMER
  | typeof FF_ANALYTICS_ZONE_HEATMAP
  | typeof FF_ANALYTICS_DRIVER_PERFORMANCE
  | typeof FF_ANALYTICS_ETA_ACCURACY
  | typeof FF_ANALYTICS_COD_COLLECTION
  | typeof FF_ANALYTICS_COST_PER_ORDER
  | typeof FF_ANALYTICS_TREND_CHARTS
  | typeof FF_MAP_PROVIDER_MAPBOX;
